import {Chip, styled} from "@mui/material";

export const TabButtonContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-end',
    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)'
}));

export const InWarehouseButtonContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column'
}));

export const SidebarTimeChip = styled(Chip)(({ theme }) => ({
    backgroundColor: theme.barekam.sidebar.filterButton.timeChip,
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: '0.75rem',

    // width: '90px',
    height: '28px',
}));